// @flow

import type { Action } from './store.type';

export const CONNECT_SHOPIFY_REQUEST = 'CONNECT_SHOPIFY_REQUEST';
type CONNECT_SHOPIFY_REQUEST_TYPE = 'CONNECT_SHOPIFY_REQUEST';

export const CONNECT_SHOPIFY_SUCCESS = 'CONNECT_SHOPIFY_SUCCESS';
type CONNECT_SHOPIFY_SUCCESS_TYPE = 'CONNECT_SHOPIFY_SUCCESS';

export const CONNECT_SHOPIFY_FAILURE = 'CONNECT_SHOPIFY_FAILURE';
type CONNECT_SHOPIFY_FAILURE_TYPE = 'CONNECT_SHOPIFY_FAILURE';

export const UPDATE_TENANT_APP_REQUEST = 'UPDATE_TENANT_APP_REQUEST';
type UPDATE_TENANT_APP_REQUEST_TYPE = 'UPDATE_TENANT_APP_REQUEST';

export const UPDATE_TENANT_APP_SUCCESS = 'UPDATE_TENANT_APP_SUCCESS';
type UPDATE_TENANT_APP_SUCCESS_TYPE = 'UPDATE_TENANT_APP_SUCCESS';

export const UPDATE_TENANT_APP_FAILURE = 'UPDATE_TENANT_APP_FAILURE';
type UPDATE_TENANT_APP_FAILURE_TYPE = 'UPDATE_TENANT_APP_FAILURE';

export const UPDATE_LOCAL_TENANT_APP = 'UPDATE_LOCAL_TENANT_APP';
type UPDATE_LOCAL_TENANT_APP_TYPE = 'UPDATE_LOCAL_TENANT_APP';

export const UPDATE_APP_SCOPES = 'UPDATE_APP_SCOPES';
type UPDATE_APP_SCOPES_TYPE = 'UPDATE_APP_SCOPES_TYPE';

export const UPDATE_FEATURE_SETTINGS = 'UPDATE_FEATURE_SETTINGS';
type UPDATE_FEATURE_SETTINGS_TYPE = 'UPDATE_FEATURE_SETTINGS_TYPE';

export const UPDATE_CURRENT_APP_INTEGRATION = 'UPDATE_CURRENT_APP_INTEGRATION';
type UPDATE_CURRENT_APP_INTEGRATION_TYPE = 'UPDATE_CURRENT_APP_INTEGRATION_TYPE';

export const UPDATE_CURRENT_APP_LANGUAGE_REQUEST = 'UPDATE_CURRENT_APP_LANGUAGE_REQUEST';
type UPDATE_CURRENT_APP_LANGUAGE_REQUEST_TYPE = 'UPDATE_CURRENT_APP_LANGUAGE_REQUEST_TYPE';

export const UPDATE_CURRENT_APP_LANGUAGE_SUCCESS = 'UPDATE_CURRENT_APP_LANGUAGE_SUCCESS';
type UPDATE_CURRENT_APP_LANGUAGE_SUCCESS_TYPE = 'UPDATE_CURRENT_APP_LANGUAGE_SUCCESS_TYPE';

export const UPDATE_CURRENT_APP_LANGUAGE_FAILURE = 'UPDATE_CURRENT_APP_LANGUAGE_FAILURE';
type UPDATE_CURRENT_APP_LANGUAGE_FAILURE_TYPE = 'UPDATE_CURRENT_APP_LANGUAGE_FAILURE_TYPE';

export const UPDATE_CURRENT_APP_VERSION_REQUEST = 'UPDATE_CURRENT_APP_VERSION_REQUEST';
type UPDATE_CURRENT_APP_VERSION_REQUEST_TYPE = 'UPDATE_CURRENT_APP_VERSION_REQUEST_TYPE';

export const UPDATE_CURRENT_APP_VERSION_SUCCESS = 'UPDATE_CURRENT_APP_VERSION_SUCCESS';
type UPDATE_CURRENT_APP_VERSION_SUCCESS_TYPE = 'UPDATE_CURRENT_APP_VERSION_SUCCESS_TYPE';

export const UPDATE_CURRENT_APP_VERSION_FAILURE = 'UPDATE_CURRENT_APP_VERSION_FAILURE';
type UPDATE_CURRENT_APP_VERSION_FAILURE_TYPE = 'UPDATE_CURRENT_APP_VERSION_FAILURE_TYPE';

export const UPDATE_WATERMARK_REQUEST = 'UPDATE_WATERMARK_REQUEST';
type UPDATE_WATERMARK_REQUEST_TYPE = 'UPDATE_WATERMARK_REQUEST_TYPE';

export const UPDATE_WATERMARK_SUCCESS = 'UPDATE_WATERMARK_SUCCESS';
type UPDATE_WATERMARK_SUCCESS_TYPE = 'UPDATE_WATERMARK_SUCCESS_TYPE';

export const UPDATE_WATERMARK_FAILURE = 'UPDATE_WATERMARK_FAILURE';
type UPDATE_WATERMARK_FAILURE_TYPE = 'UPDATE_WATERMARK_FAILURE_TYPE';

export const GET_TENANT_APP_GROUPS_REQUEST = 'GET_TENANT_APP_GROUPS_REQUEST';
type GET_TENANT_APP_GROUPS_REQUEST_TYPE = 'GET_TENANT_APP_GROUPS_REQUEST_TYPE';

export const GET_TENANT_APP_GROUPS_SUCCESS = 'GET_TENANT_APP_GROUPS_SUCCESS';
type GET_TENANT_APP_GROUPS_SUCCESS_TYPE = 'GET_TENANT_APP_GROUPS_SUCCESS_TYPE';

export const GET_TENANT_APP_GROUPS_FAILURE = 'GET_TENANT_APP_GROUPS_FAILURE';
type GET_TENANT_APP_GROUPS_FAILURE_TYPE = 'GET_TENANT_APP_GROUPS_FAILURE_TYPE';

export const UNAUTHORIZED_ACCESS = 'UNAUTHORIZED_ACCESS';
type UNAUTHORIZED_ACCESS_TYPE = 'UNAUTHORIZED_ACCESS_TYPE';

export const UPDATE_QUERY_PARAMS = 'UPDATE_QUERY_PARAMS';
type UPDATE_QUERY_PARAMS_TYPE = 'UPDATE_QUERY_PARAMS_TYPE';

export const UPDATE_SMART_STYLING_LIMITATION = 'UPDATE_SMART_STYLING_LIMITATION';
type UPDATE_SMART_STYLING_LIMITATION_TYPE = 'UPDATE_SMART_STYLING_LIMITATION';

type ConnectShopifySuccess = {
  data: {
    tenantApp: Object,
    authToken: string
  }
};

type UpdateTenantAppSuccess = {
  data: {
    tenantApp: Object
  }
};

type OauthFailure = {
  error: any
};

type UpdateCurrentAppLanguageSuccess = {
  data: {
    appLanguage: string
  }
};

type ConnectShopifyRequestAction = Action<CONNECT_SHOPIFY_REQUEST_TYPE, null>;

type ConnectShopifySuccessAction = Action<CONNECT_SHOPIFY_SUCCESS_TYPE, ConnectShopifySuccess>;

type ConnectShopifyFailureAction = Action<CONNECT_SHOPIFY_FAILURE_TYPE, OauthFailure>;

type UpdateTenantAppRequestAction = Action<UPDATE_TENANT_APP_REQUEST_TYPE, null>;

type UpdateTenantAppSuccessAction = Action<UPDATE_TENANT_APP_SUCCESS_TYPE, UpdateTenantAppSuccess>;

type UpdateTenantAppFailureAction = Action<UPDATE_TENANT_APP_FAILURE_TYPE, OauthFailure>;

type UpdateLocalTenantAppAction = Action<UPDATE_LOCAL_TENANT_APP_TYPE, null>;

type UpdateAppScopesAction = Action<UPDATE_APP_SCOPES_TYPE, null>;
type UpdateFeatureSettingsAction = Action<UPDATE_FEATURE_SETTINGS_TYPE, null>;

type UpdateCurrentAppIntegrationAction = Action<UPDATE_CURRENT_APP_INTEGRATION_TYPE, null>;

type UpdateCurrentAppLanguageRequestAction = Action<UPDATE_CURRENT_APP_LANGUAGE_REQUEST_TYPE, null>;
type UpdateCurrentAppLanguageSuccessAction = Action<
  UPDATE_CURRENT_APP_LANGUAGE_SUCCESS_TYPE,
  UpdateCurrentAppLanguageSuccess
>;
type UpdateCurrentAppLanguageFailureAction = Action<
  UPDATE_CURRENT_APP_LANGUAGE_FAILURE_TYPE,
  OauthFailure
>;

type UpdateCurrentAppVersionRequestAction = Action<UPDATE_CURRENT_APP_VERSION_REQUEST_TYPE, null>;
type UpdateCurrentAppVersionSuccessAction = Action<
  UPDATE_CURRENT_APP_VERSION_SUCCESS_TYPE,
  UpdateCurrentAppVersionSuccess
>;
type UpdateCurrentAppVersionFailureAction = Action<
  UPDATE_CURRENT_APP_VERSION_FAILURE_TYPE,
  OauthFailure
>;

type UpdateWatermarkRequestAction = Action<UPDATE_WATERMARK_REQUEST_TYPE, null>;
type UpdateWatermarkSuccessAction = Action<UPDATE_WATERMARK_SUCCESS_TYPE, any>;
type UpdateWatermarkFailureAction = Action<UPDATE_WATERMARK_FAILURE_TYPE, OauthFailure>;

type GetTenantAppGroupsRequestAction = Action<GET_TENANT_APP_GROUPS_REQUEST_TYPE, null>;
type GetTenantAppGroupsSuccessAction = Action<GET_TENANT_APP_GROUPS_SUCCESS_TYPE, any>;
type GetTenantAppGroupsFailureAction = Action<GET_TENANT_APP_GROUPS_FAILURE_TYPE, null>;

type UnauthorizedAccessAction = Action<UNAUTHORIZED_ACCESS_TYPE, null>;

type UpdateQueryParamsAction = Action<UPDATE_QUERY_PARAMS_TYPE, any>;

type UpdateSmartStylingLimitationAction = Action<UPDATE_SMART_STYLING_LIMITATION_TYPE, any>;

export type OauthAction =
  | ConnectShopifyRequestAction
  | ConnectShopifySuccessAction
  | ConnectShopifyFailureAction
  | UpdateTenantAppRequestAction
  | UpdateTenantAppSuccessAction
  | UpdateTenantAppFailureAction
  | UpdateLocalTenantAppAction
  | UpdateAppScopesAction
  | UpdateFeatureSettingsAction
  | UpdateCurrentAppIntegrationAction
  | UpdateCurrentAppLanguageRequestAction
  | UpdateCurrentAppLanguageSuccessAction
  | UpdateCurrentAppLanguageFailureAction
  | UpdateCurrentAppVersionFailureAction
  | UpdateCurrentAppVersionRequestAction
  | UpdateCurrentAppVersionSuccessAction
  | UpdateWatermarkRequestAction
  | UpdateWatermarkSuccessAction
  | UpdateWatermarkFailureAction
  | UnauthorizedAccessAction
  | GetTenantAppGroupsRequestAction
  | GetTenantAppGroupsSuccessAction
  | GetTenantAppGroupsFailureAction
  | UpdateQueryParamsAction
  | UpdateSmartStylingLimitationAction;

export type OauthState = {
  loading: boolean,
  connectSuccess: boolean,
  success: boolean,
  error: any,
  connected: boolean,
  authToken: string,
  tenantApp: Object,
  host: string,
  emailSupport: string,
  loadingUpdate: boolean
};
